import Modal from "@mui/material/Modal"
import Paper from "@mui/material/Paper"
import Box from "@mui/material/Box"

import Typography from "@mui/material/Typography"
import {sx} from './sx'
import {FC, ReactElement} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";
import ToggleScreenModeButton from "../buttons/toggleScreenModeButton/ToggleScreenModeButton"
import {SetStatePropsType} from "@baseTypes/base";
import {classNames} from "@helpers/classNames";
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import {MODAL_COMPONENT_PROPS} from "@ui/modal/constants/modalProps";

interface IProps {
    fullScreenMode: boolean,
    setFullScreenMode: SetStatePropsType<boolean>,
    children: ReactElement,
    label?: string,
    sx?: SxType,
    showActionPanel?: boolean,
    className?: string,
}

const ModalFullScreen: FC<IProps> = ({
                                         fullScreenMode,
                                         setFullScreenMode,
                                         children,
                                         label,
                                         showActionPanel = true,
                                         className,
                                         sx: sxProps = {},
                                     }) => {
    const {theme} = useThemeContext()
    const onClose = () => {
        if (setFullScreenMode) {
            setFullScreenMode(false)
        }
    }

    if (!fullScreenMode) {
        return <>
            {children}
        </>
    }

    return (
        <Modal
            open={fullScreenMode}
            onClose={onClose}
            componentsProps={MODAL_COMPONENT_PROPS}
        >
            <Paper
                sx={{
                    ...sx.box,
                    ...sxProps,
                } as SxType}
                className={classNames(fullScreenMode && 'fullScreenMode', 'modalFullScreenBox', className, theme === 'dark' ? 'darkTheme' : 'lightTheme')}
            >
                <Box sx={sx.content}>
                    {showActionPanel && <Box sx={sx.action}>
                        <Box sx={sx.inner}>
                            {label && <Typography sx={sx.title} variant={'body1'}>
                                {label}
                            </Typography>}

                            <ToggleScreenModeButton
                                sx={sx.btn}
                                fullScreenMode={fullScreenMode}
                                setFullScreenMode={setFullScreenMode}
                            />

                        </Box>
                    </Box>}
                    {children}
                </Box>
            </Paper>
        </Modal>
    );
};

export default ModalFullScreen;